<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-4 offset-md-4">
                    <div class="pt-5">
                        <!--<div class="card-header bg-convergenze">
                            <div class="row">
                                <div class="col-12">
                                    <img src="../assets/Logo_bianco.svg" width="250px">
                                </div>
                            </div>
                        </div>-->
                        <div class="card-body">
                            <h5 class="card-title">
                                <div class="d-flex align-items-center justify-content-center">
                                     <img src="../assets/icona_helpcenter.png" class="pr-2" width="50px"> &nbsp;Parla con un nostro operatore!
                                </div>
                            </h5>
                            <div class="card-text">
                                <div class="row pt-1" >
                                    <div class="col-md-12 text-left">
                                        <input type="text" class="form-control" placeholder="Il tuo nome" required v-model="username" id="username">
                                    </div>
                                </div>
                                <div class="row pt-2" >
                                    <div class="col-md-12 text-left">
                                        <select class="form-control" v-model="argomento" id="argomento">
                                            <option :value="null" disabled>Come possiamo aiutarti?</option>
                                            <option :value="this.define.ARGOMENTO_FRONT">Informazioni (offerte, servizi..)</option>
                                            <option :value="this.define.ARGOMENTO_AMMINISTRAZIONE">Supporto amministrativo (pagamenti, informazioni sulle fatture...)</option>
                                            <option :value="this.define.ARGOMENTO_SUPPORTO">Assistenza tecnica (guasti, problemi di connessione...)</option>
                                            <option :value="this.define.ARGOMENTO_ENERGIA">Supporto energia (luce, gas, EVO...) </option>
                                        </select>
                                    </div>
                                </div>
                                <!--<div class="row pt-2" >
                                    <div class="col-md-12 text-left">
                                        <textarea class="form-control" placeholder="Scrivi il messaggio" required v-model="first_message" id="first_message"></textarea>
                                    </div>
                                </div>-->
                                <div class="row pt-4" >
                                    <div class="col-md-12 text-center">
                                        <button type="button" v-on:click="startChat" :disabled="isStartChat" class="btn btn-primary bg-convergenze">Inizia Chat</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            
        </div>
        <b-modal id="modal-sm" ref="modal-error" size="lg" title="Compila tutti i campi">
            <div class="row">
                <div class="col-12 text-center">
                    <h5>
                        Inserisci l'username e l'argomento!
                    </h5>
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-9"></div>
                <div class="col-3 d-flex justify-content-end">
                    <b-button class="mt-2 mx-1" variant="outline-secondary"  block @click="hideModal">Chiudi</b-button>
                </div>
            </div>
        </b-modal>
    </div>
</template>


<script>

import ChatStorage from '../models/ChatStorage'
import BackendApi from '../models/BackendApi'
import defapp from '../models/defapp'


export default {
    name: 'Index',
    data: function() {
        return {
            username: "",
            first_message: "",
            userData: JSON.parse(localStorage.getItem('userLogged')),
            define: defapp,
            argomento: null,
            isStartChat: false,
            array_province: [],
            array_comuni: [],
            startChatAutomatic: false,
        };  
    },
    components: {    
    },
    computed: {       
    },
    methods: {    
        
        startChat: function()
        {
            if(this.username == "" || this.argomento == null)
            {
                //alert("Inserisci l'username, il reparto e un messaggio di motivazione");
                this.$refs['modal-error'].show()
                return false;
            } else {
                this.isStartChat = true;
                localStorage.setItem("usernameClient",this.username);
                //localStorage.setItem("messageMotivazione",this.first_message);
                localStorage.setItem("argomento",this.argomento);
                this.$router.push('/client-chat')
            }
           

        },
        hideModal: function()
        {
            this.$refs['modal-error'].hide()
        },
        continueLogin: function()
        {
            let api = new BackendApi(this.configApp)
            let chatStorage = new ChatStorage(this.configApp);
            let chat_open_exts = chatStorage.getChatID();
            let accountId = this.$route.query.accountid
            let isAdmin = this.$route.query.isAdmin
            let tag = this.$route.query.tag
            let searchTag = false
            console.log("continueLogin");
            if (chat_open_exts != 0 )
            {
                console.log("CHAT EXT");
                console.log(accountId)

                if(accountId != null && accountId != undefined && accountId.length > 0)
                {
                    api.updateAccountChat(chat_open_exts,accountId, (result) => {
                        if(result.success == false)
                        {
                           console.log("ERRORE updateAccountChat")
                        }
                        
                    });
                    accountId = "";
                }

                this.$router.push('/client-chat');
            }

            let params_fonte = this.$route.query.fonte
        
            if(params_fonte != null && params_fonte.length > 0 && params_fonte != undefined)
            {
                localStorage.setItem("fonte",params_fonte);
            }


            if(isAdmin == null || isAdmin == undefined || isAdmin.length == 0) 
            {
                isAdmin = "false"
            }            
            
            if(accountId != null && accountId != undefined && accountId.length > 0)
            {
                if(isAdmin == "false")
                {
                    console.log("START LOGIN");
                    if (tag !== undefined && tag.length > 0)
                    {
                        searchTag = true;
                    }
                    api.login("","","",accountId,tag, (result) => {
                        if(result.accountId > 0)
                        {
                            this.username = result.name
                        }

                        console.log("result.startChatAutomatic "+result.startChatAutomatic);
                        
                        if (result.startChatAutomatic == true)
                        {
                            this.startChatAutomatic = true
                            localStorage.setItem("startChatMessage",true)
                            localStorage.setItem("automatic-message",result.messaggio);
                            localStorage.setItem("argomento", result.argomento);
                            this.argomento = result.argomento;
                            this.startChat()
                        }
                    });
                }
            }

            if (tag != null && tag != undefined && tag.length > 0 && searchTag == false)
            {
                api.login("","","",0,tag, (result) => {
                searchTag = true;
                
                if (result.startChatAutomatic == true)
                {
                    this.username = "Porta un Amico"
                    this.startChatAutomatic = true
                    localStorage.setItem("startChatMessage",true)
                    localStorage.setItem("automatic-message",result.messaggio);
                    localStorage.setItem("argomento", result.argomento);
                    this.argomento = result.argomento;
                    this.startChat()
                }
                });
            }

        }
    },
    created: function() { 

        let api = new BackendApi(this.configApp)
        let accountId = this.$route.query.accountid
        let chatStorage = new ChatStorage(this.configApp);
        if(this.userData != null)
        {
            //CHECK VALIDAZIONE CREDENZIALI
            api.verificaAuth(this.userData.tokenAccess,this.userData.userId,accountId, (result) => {
                if(result.success == false)
                {
                    this.userData = null;
                    chatStorage.deleteStorageChatId()
                    localStorage.removeItem('userLogged')
                    this.continueLogin()
                     
                } else {
                    this.continueLogin()
                }
            })
        } else {
            this.continueLogin()
        }

        
        
    },
    mounted:function(){
        
    },
}

</script>